<template>
    <div>
        <template>
            <tabs fill class="flex-column flex-md-row">
                <card shadow>                                    

                    <tab-pane 
                        title="Medical Applications"
                        @tab-activated="triggerMedicalApplications"
                    >
                        <span slot="title">
                            <i class="ni ni-books"></i>
                            Medical Applications
                        </span>
                        <!-- import Medical Applications template here --> 
                        <MedicalApplications
                            :privileges="privileges"
                            :changeTitle="changeTitle"
                            :loadTitle="loadTitle"
                            :id="id"
                            :type="'medical'"
                            ref="callMedicalApplications"
                            v-if="activated.medical"
                        />
                    </tab-pane>

                    <tab-pane 
                        title="Dental Applications"
                        @tab-activated="triggerDentalApplications"
                    >
                        <span slot="title">
                            <i class="ni ni-badge"></i>
                            Dental Applications
                        </span>
                        <!-- import Medical Applications template here -->
                        <MedicalApplications
                            :privileges="privileges"
                            :changeTitle="changeTitle"
                            :loadTitle="loadTitle"
                            :id="id"
                            :type="'dental'"
                            ref="callDentalApplications"
                            v-if="activated.dental"
                        />
                    </tab-pane>

                </card>
            </tabs>
        </template>
    </div>
</template>
<script>
    import MedicalApplications from './MedicalApplications.vue'; 

    export default {
        name: 'RemediationApplications',
        props: ['privileges', 'changeTitle', 'loadTitle', 'id'],
        data() {
            return {
                activated: { 
                    medical: true, 
                    dental: false 
                }
            };
        },
        components: {
            MedicalApplications
        },
        methods: {
            triggerMedicalApplications() {
                return this.activated = { medical: true, dental: false }
            },
            triggerDentalApplications() {
                return this.activated = { medical: false, dental: true }
            }
        }
    };
</script>
<style></style>
